// extracted by mini-css-extract-plugin
export default {"needMapping":"LeonB-List_needMapping__En4UZ","noMapping":"LeonB-List_noMapping__ywE7G"};